import startCase from "lodash/startCase";

export const getFormValuesObject = (formValues) =>
  Object.keys(formValues).reduce((acc, formVal) => {
    acc[formVal] = formValues[formVal].value;
    return acc;
  }, {});

export const formatOrderCheckoutErrors = (error) => {
  let errors = [];
  const errorArr = error?.data?.attributes?.error_details?.errors || [];
  errorArr.map(({ detail, source }) => {
    const keyArr = source?.pointer?.split("/");
    const key = keyArr[keyArr.length - 1].split(".");
    const keyString = key?.toString() !== "base" ? `${startCase(key)} ` : "";
    errors.push(`${keyString}${detail}`);
  });
  return errors;
};
